import hero from '../assets/infographics/hero.webp';
import one from '../assets/infographics/1.webp';
import two from '../assets/infographics/2.webp';
import three from '../assets/infographics/3.webp';
import four from '../assets/infographics/4.webp';
import five from '../assets/infographics/5.webp';
import six from '../assets/infographics/6.webp';
import seven from '../assets/infographics/7.webp';
import eight from '../assets/infographics/8.webp';
import nine from '../assets/infographics/9.webp';
import ten from '../assets/infographics/10.webp';
import eleven from '../assets/infographics/11.webp';
import twelve from '../assets/infographics/12.webp';
import thirteen from '../assets/infographics/13.webp';
import fourteen from '../assets/infographics/14.webp';
import fifteen from '../assets/infographics/15.webp';
import sixteen from '../assets/infographics/16.webp';
import seventeen from '../assets/infographics/17.webp';
import eighteen from '../assets/infographics/18.webp';
import nineteen from '../assets/infographics/19.webp';
import twenty from '../assets/infographics/20.webp';
import twentyone from '../assets/infographics/21.webp';
import twentytwo from '../assets/infographics/22.webp';
import twentythree from '../assets/infographics/23.webp';
import twentyfour from '../assets/infographics/24.webp';
import twentyfive from '../assets/infographics/25.webp';
import twentysix from '../assets/infographics/26.webp';
import twentyseven from '../assets/infographics/27.webp';
import twentyeight from '../assets/infographics/28.webp';
import twentynine from '../assets/infographics/29.webp';
import thirty from '../assets/infographics/30.webp';
import thirtyone from '../assets/infographics/31.webp';
import thirtytwo from '../assets/infographics/32.webp';
import thirtythree from '../assets/infographics/33.webp';
import thirtyfour from '../assets/infographics/34.webp';
import thirtyfive from '../assets/infographics/35.webp';
import thirtysix from '../assets/infographics/36.webp';
import thirtyseven from '../assets/infographics/37.webp';
import thirtyeight from '../assets/infographics/38.webp';
import thirtynine from '../assets/infographics/39.webp';
import forty from '../assets/infographics/40.webp';
import fortyone from '../assets/infographics/41.webp';
import fortytwo from '../assets/infographics/42.webp';
import fortythree from '../assets/infographics/43.webp';
import fortyfour from '../assets/infographics/44.webp';
import fortyfive from '../assets/infographics/45.webp';
import fortysix from '../assets/infographics/46.webp';
import fortyseven from '../assets/infographics/47.webp';
import fortyeight from '../assets/infographics/48.webp';
import fortynine from '../assets/infographics/49.webp';
import fifty from '../assets/infographics/50.webp';
import fiftyone from '../assets/infographics/51.webp';
import fiftytwo from '../assets/infographics/52.webp';
import heuristics1 from '../assets/infographics/heuristics-1-Visibility.webp';
import heuristics2 from '../assets/infographics/heuristics-2-Match.webp';
import heuristics3 from '../assets/infographics/heuristics-3-User.webp';
import heuristics4 from '../assets/infographics/heuristics-4-Consistency.webp';
import heuristics5 from '../assets/infographics/heuristics-5-Error.webp';
import heuristics6 from '../assets/infographics/heuristics-6-Recognition.webp';
import heuristics7 from '../assets/infographics/heuristics-7-Flexibility.webp';
import heuristics8 from '../assets/infographics/heuristics-8-Aesthetic.webp';
import heuristics9 from '../assets/infographics/heuristics-9-Help.webp';
import heuristics10 from '../assets/infographics/heuristics-10-Documentation.webp';
import uxlaw1 from '../assets/infographics/uxlaw-1-hick.webp';
import uxlaw2 from '../assets/infographics/uxlaw-2-fitt.webp';
import uxlaw3 from '../assets/infographics/uxlaw-3-jakob.webp';
import uxlaw4 from '../assets/infographics/uxlaw-4-miller.webp';
import uxlaw5 from '../assets/infographics/uxlaw-5-tesler.webp';
import uxlaw6 from '../assets/infographics/uxlaw-6-pareto.webp';
import uxlaw7 from '../assets/infographics/uxlaw-7-zeigarnik.webp';
import uxlaw8 from '../assets/infographics/uxlaw-8-aesthetic.webp';
import uxResearch1 from '../assets/infographics/ux-research.webp';
import uxResearch2 from '../assets/infographics/ux-research-2.webp';
import biases1 from '../assets/infographics/biases1.webp';
import secondSet1 from '../assets/infographics/secondset-1.webp';
import secondSet2 from '../assets/infographics/secondset-2.webp';
import secondSet2_1 from '../assets/infographics/secondset-2-1.webp';
import secondSet3 from '../assets/infographics/secondset-3.webp';
import secondSet4 from '../assets/infographics/secondset-4.webp';
import secondSet5 from '../assets/infographics/secondset-5.webp';
import secondSet6 from '../assets/infographics/secondset-6.webp';
import secondSet7 from '../assets/infographics/secondset-7.webp';
import secondSet7_1 from '../assets/infographics/secondset-7-1.webp';
import secondSet8 from '../assets/infographics/secondset-8.webp';
import secondSet9 from '../assets/infographics/secondset-9.webp';
import secondSet10 from '../assets/infographics/secondset-10.webp';
import secondSet10_1 from '../assets/infographics/secondset-10-1.webp';
import secondSet11 from '../assets/infographics/secondset-11.webp';
import secondSet12 from '../assets/infographics/secondset-12.webp';
import secondSet13 from '../assets/infographics/secondset-13.webp';
import secondSet13_1 from '../assets/infographics/secondset-13-1.webp';
import secondSet14 from '../assets/infographics/secondset-14.webp';
import secondSet15 from '../assets/infographics/secondset-15.webp';
import secondSet16 from '../assets/infographics/secondset-16.webp';
import secondSet17 from '../assets/infographics/secondset-17.webp';
import secondSet18 from '../assets/infographics/secondset-18.webp';
import secondSet19 from '../assets/infographics/secondset-19.webp';
import secondSet20 from '../assets/infographics/secondset-20.webp';
import secondSet21 from '../assets/infographics/secondset-21.webp';
import secondSet22 from '../assets/infographics/secondset-22.webp';
import secondSet23 from '../assets/infographics/secondset-23.webp';
import secondSet24 from '../assets/infographics/secondset-24.webp';
import secondSet25 from '../assets/infographics/secondset-25.webp';
import secondSet26 from '../assets/infographics/secondset-26.webp';
import secondSet27 from '../assets/infographics/secondset-27.webp';
import secondSet28 from '../assets/infographics/secondset-28.webp';
import secondSet29 from '../assets/infographics/secondset-29.webp';
import secondSet30 from '../assets/infographics/secondset-30.webp';
import secondSet31 from '../assets/infographics/secondset-31.webp';
import secondSet32 from '../assets/infographics/secondset-32.webp';
import secondSet33 from '../assets/infographics/secondset-33.webp';
import secondSet34 from '../assets/infographics/secondset-34.webp';
import thirdSet1 from '../assets/infographics/thirdset-1.webp';
import thirdSet2 from '../assets/infographics/thirdset-2.webp';
import thirdSet3 from '../assets/infographics/thirdset-3.webp';
import thirdSet4 from '../assets/infographics/thirdset-4.webp';
import thirdSet5 from '../assets/infographics/thirdset-5.webp';
import thirdSet6 from '../assets/infographics/thirdset-6.webp';
import thirdSet7 from '../assets/infographics/thirdset-7.webp';
import thirdSet8 from '../assets/infographics/thirdset-8.webp';
import thirdSet9 from '../assets/infographics/thirdset-9.webp';
import thirdSet10 from '../assets/infographics/thirdset-10.webp';
import thirdSet11 from '../assets/infographics/thirdset-11.webp';
import thirdSet12 from '../assets/infographics/thirdset-12.webp';
import thirdSet13 from '../assets/infographics/thirdset-13.webp';
import thirdSet14 from '../assets/infographics/thirdset-14.webp';
import thirdSet15 from '../assets/infographics/thirdset-15.webp';
import thirdSet16 from '../assets/infographics/thirdset-16.webp';
import thirdSet17 from '../assets/infographics/thirdset-17.webp';
import thirdSet18 from '../assets/infographics/thirdset-18.webp';
import thirdSet19 from '../assets/infographics/thirdset-19.webp';
import thirdSet20 from '../assets/infographics/thirdset-20.webp';
import thirdSet21 from '../assets/infographics/thirdset-21.webp';
import thirdSet22 from '../assets/infographics/thirdset-22.webp';
import thirdSet23 from '../assets/infographics/thirdset-23.webp';
import thirdSet24 from '../assets/infographics/thirdset-24.webp';
import thirdSet25 from '../assets/infographics/thirdset-25.webp';
import thirdSet26 from '../assets/infographics/thirdset-26.webp';
import thirdSet27 from '../assets/infographics/thirdset-27.webp';
import thirdSet28 from '../assets/infographics/thirdset-28.webp';
import thirdSet29 from '../assets/infographics/thirdset-29.webp';
import thirdSet30 from '../assets/infographics/thirdset-30.webp';
import thirdSet31 from '../assets/infographics/thirdset-31.webp';
import thirdSet32 from '../assets/infographics/thirdset-32.webp';
import thirdSet33 from '../assets/infographics/thirdset-33.webp';
import thirdSet34 from '../assets/infographics/thirdset-34.webp';
import thirdSet35 from '../assets/infographics/thirdset-35.webp';
import thirdSet36 from '../assets/infographics/thirdset-36.webp';
import thirdSet37 from '../assets/infographics/thirdset-37.webp';
import thirdSet38 from '../assets/infographics/thirdset-38.webp';
import thirdSet39 from '../assets/infographics/thirdset-39.webp';
import thirdSet40 from '../assets/infographics/thirdset-40.webp';
import thirdSet41 from '../assets/infographics/thirdset-41.webp';
import thirdSet42 from '../assets/infographics/thirdset-42.webp';
import thirdSet43 from '../assets/infographics/thirdset-43.webp';
import thirdSet44 from '../assets/infographics/thirdset-44.webp';
import thirdSet45 from '../assets/infographics/thirdset-45.webp';
import thirdSet46 from '../assets/infographics/thirdset-46.webp';
import thirdSet47 from '../assets/infographics/thirdset-47.webp';
import thirdSet48 from '../assets/infographics/thirdset-48.webp';
import thirdSet49 from '../assets/infographics/thirdset-49.webp';
import thirdSet50 from '../assets/infographics/thirdset-50.webp';
import thirdSet51 from '../assets/infographics/thirdset-51.webp';
import thirdSet52 from '../assets/infographics/thirdset-52.webp';
import thirdSet53 from '../assets/infographics/thirdset-53.webp';
import thirdSet54 from '../assets/infographics/thirdset-54.webp';
import thirdSet55 from '../assets/infographics/thirdset-55.webp';
import thirdSet56 from '../assets/infographics/thirdset-56.webp';
import thirdSet57 from '../assets/infographics/thirdset-57.webp';

const mediaMap = {
    hero,
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
    thirteen,
    fourteen,
    fifteen,
    sixteen,
    seventeen,
    eighteen,
    nineteen,
    twenty,
    twentyone,
    twentytwo,
    twentythree,
    twentyfour,
    twentyfive,
    twentysix,
    twentyseven,
    twentyeight,
    twentynine,
    thirty,
    thirtyone,
    thirtytwo,
    thirtythree,
    thirtyfour,
    thirtyfive,
    thirtysix,
    thirtyseven,
    thirtyeight,
    thirtynine,
    forty,
    fortyone,
    fortytwo,
    fortythree,
    fortyfour,
    fortyfive,
    fortysix,
    fortyseven,
    fortyeight,
    fortynine,
    fifty,
    fiftyone,
    fiftytwo,
    heuristics1,
    heuristics2,
    heuristics3,
    heuristics4,
    heuristics5,
    heuristics6,
    heuristics7,
    heuristics8,
    heuristics9,
    heuristics10,
    uxlaw1,
    uxlaw2,
    uxlaw3,
    uxlaw4,
    uxlaw5,
    uxlaw6,
    uxlaw7,
    uxlaw8,
    uxResearch1,
    uxResearch2,
    biases1,
    secondSet1,
    secondSet2,
    secondSet2_1,
    secondSet3,
    secondSet4,
    secondSet5,
    secondSet6,
    secondSet7,
    secondSet7_1,
    secondSet8,
    secondSet9,
    secondSet10,
    secondSet10_1,
    secondSet11,
    secondSet12,
    secondSet13,
    secondSet13_1,
    secondSet14,
    secondSet15,
    secondSet16,
    secondSet17,
    secondSet18,
    secondSet19,
    secondSet20,
    secondSet21,
    secondSet22,
    secondSet23,
    secondSet24,
    secondSet25,
    secondSet26,
    secondSet27,
    secondSet28,
    secondSet29,
    secondSet30,
    secondSet31,
    secondSet32,
    secondSet33,
    secondSet34,
    thirdSet1,
    thirdSet2,
    thirdSet3,
    thirdSet4,
    thirdSet5,
    thirdSet6,
    thirdSet7,
    thirdSet8,
    thirdSet9,
    thirdSet10,
    thirdSet11,
    thirdSet12,
    thirdSet13,
    thirdSet14,
    thirdSet15,
    thirdSet16,
    thirdSet17,
    thirdSet18,
    thirdSet19,
    thirdSet20,
    thirdSet21,
    thirdSet22,
    thirdSet23,
    thirdSet24,
    thirdSet25,
    thirdSet26,
    thirdSet27,
    thirdSet28,
    thirdSet29,
    thirdSet30,
    thirdSet31,
    thirdSet32,
    thirdSet33,
    thirdSet34,
    thirdSet35,
    thirdSet36,
    thirdSet37,
    thirdSet38,
    thirdSet39,
    thirdSet40,
    thirdSet41,
    thirdSet42,
    thirdSet43,
    thirdSet44,
    thirdSet45,
    thirdSet46,
    thirdSet47,
    thirdSet48,
    thirdSet49,
    thirdSet50,
    thirdSet51,
    thirdSet52,
    thirdSet53,
    thirdSet54,
    thirdSet55,
    thirdSet56,
    thirdSet57
};

class MediaContainer extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    static get observedAttributes() {
        return ['src', 'type', 'options', 'description'];
    }

    connectedCallback() {
        this.render();
        this.addEventListeners();
    }

    attributeChangedCallback() {
        if (this.shadowRoot.innerHTML !== '') {
            this.render();
        }
    }

    render() {
        const src = this.getAttribute('src') || '';
        const type = this.getAttribute('type') || 'image';
        const options = this.getAttribute('options') || '';
        const description = this.getAttribute('description') || '';

        // Parse options into attributes
        const optionsObj = options ? this.parseOptions(options) : {};
        const optionsString = Object.entries(optionsObj)
            .map(([key, value]) => `${key}="${value}"`)
            .join(' ');

        let mediaElement = '';
        if (type === 'image') {
            mediaElement = `<img src="${mediaMap[src]}" alt="${description}" ${optionsString} />`;
        } else if (type === 'video') {
            mediaElement = `
        <video controls ${optionsString}>
          <source src="${src}" type="video/${src.split('.').pop()}">
          Your browser does not support the video tag.
        </video>
      `;
        }

        this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          margin-bottom: var(--space-8, 2rem);
        }
        
        .media-container {
          width: 100%;
          cursor: pointer;
          border-radius: var(--border-radius-md, 0.5rem);
          overflow: hidden;
          transition: transform 0.2s ease;
          box-shadow: var(--shadow-md, 0 4px 6px rgba(0, 0, 0, 0.05));
        }
        
        .media-container:hover {
          transform: translateY(-2px);
        }
        
        img, video {
          display: block;
          width: 100%;
          height: auto;
          object-fit: contain;
        }
        
        .description {
          margin-top: var(--space-4, 1rem);
          text-align: center;
          color: var(--light-text-color, #6b7280);
          font-size: 0.925rem;
        }
        
        /* Modal styles */
        .modal {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.9);
          z-index: 1000;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        
        .modal.open {
          display: flex;
        }
        
        .modal-content {
          max-width: 90%;
          max-height: 80%;
        }
        
        .modal img, .modal video {
          max-width: 100%;
          max-height: 80vh;
          object-fit: contain;
        }
        
        .modal-description {
          color: white;
          margin-top: var(--space-4, 1rem);
          text-align: center;
          max-width: 80%;
          font-size: 1rem;
        }
        
        .close-btn {
          position: absolute;
          top: var(--space-4, 1rem);
          right: var(--space-4, 1rem);
          color: white;
          font-size: 2rem;
          cursor: pointer;
          background: none;
          border: none;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.5);
          transition: background-color 0.2s;
        }
        
        .close-btn:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
        
        @media (max-width: 768px) {
          .modal-content {
            max-width: 95%;
          }
        }
      </style>
      
      <div class="media-container" tabindex="0" aria-label="Click to view in fullscreen">
        ${mediaElement}
      </div>
      
      ${description ? `<div class="description">${description}</div>` : ''}
      
      <div class="modal" role="dialog" aria-label="Fullscreen media">
        <button class="close-btn" aria-label="Close fullscreen view">&times;</button>
        <div class="modal-content">
          ${mediaElement}
        </div>
        ${description ? `<div class="modal-description">${description}</div>` : ''}
      </div>
    `;
    }

    parseOptions(optionsStr) {
        const result = {};
        try {
            // Convert string like 'autoplay loop' to {autoplay: '', loop: ''}
            // Or 'width=500 height=300' to {width: '500', height: '300'}
            optionsStr.split(' ').forEach(opt => {
                if (opt.includes('=')) {
                    const [key, value] = opt.split('=');
                    result[key] = value;
                } else if (opt.trim()) {
                    result[opt.trim()] = '';
                }
            });
        } catch (e) {
            console.error('Error parsing options', e);
        }
        return result;
    }

    addEventListeners() {
        const container = this.shadowRoot.querySelector('.media-container');
        const modal = this.shadowRoot.querySelector('.modal');
        const closeBtn = this.shadowRoot.querySelector('.close-btn');

        // Open modal on click
        container.addEventListener('click', () => this.openModal());

        // Keyboard accessibility for Enter key
        container.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.openModal();
            }
        });

        // Close modal on close button click
        closeBtn.addEventListener('click', e => {
            e.stopPropagation();
            this.closeModal();
        });

        // Close modal on Escape key
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' || e.keyCode === 27) {
                this.closeModal();
            }
        });

        // Close modal on click outside content
        modal.addEventListener('click', e => {
            if (e.target === modal) {
                this.closeModal();
            }
        });
    }

    openModal() {
        const modal = this.shadowRoot.querySelector('.modal');
        modal.classList.add('open');
        document.body.style.overflow = 'hidden'; // Prevent scrolling while modal is open
    }

    closeModal() {
        const modal = this.shadowRoot.querySelector('.modal');
        modal.classList.remove('open');
        document.body.style.overflow = ''; // Restore scrolling
    }
}

customElements.define('media-container', MediaContainer);
